export default "__VITE_ASSET__BKwq4XCq__"